/** Generated by scripts/generate-choreography-v2-mappings.js — do not edit */
module.exports = {};
